<div class="dialog-container">
  <div class="top-container">
    <div class="system-lock-img flex_sb">
      <div>
        <p class="m-0 ta_center fw-700 lh-130 system-lock-text">
          {{ 'SYSTEM_LOCKED' | fallbackTranslate | uppercase }}
        </p>
        <p class="m-0 ta_center clr-333 lh-130 fw-600 miss-you">
          {{ 'WE_MISS_YOU' | fallbackTranslate }}
        </p>
      </div>
      <img [src]="images.LOCKED_IMG_LITE" alt="locked-img"/>
    </div>
    <div class="locked-info">
      <div class="clr-333 ta_center fw-600 lh-130 payemnt-due-text">
        {{ 'YOUR_PAYMENT_IS_DUE' | fallbackTranslate }}
      </div>
      <div class="pending-due ta_center" *ngIf="pendingAmount">
        <div class="pending-due-label clr-666 fw-600">{{ amountDueLabel }}</div>
        <div class="pending-due-amount fw-700">
          {{ currency }} {{ pendingAmount }}
        </div>
      </div>
      <div class="clr-666 ta_center fw-400 lh-130 locked-text">
        {{ 'YOUR_ACCOUNT_HAS_BEEN_LOCKED' | fallbackTranslate }}
      </div>
      <div class="clr-666 ta_center fw-400 lh-130 contact-text">
        {{ 'KINDLY_REACH_OUT_TO_US_AT' | fallbackTranslate }}
        <span class="fw-700"> {{ isIndo ? '+62 817-880-144' : '+60 12-301 4549'}} </span>
        {{ 'IN_CASE_YOU_HAVE_ANY_QUESTIONS' | fallbackTranslate }}
      </div>
      <div class="pay-unlock ta_center">
        <p class="m-0 pay-unlock-hint clr-333">
          <span class="fw-600">{{ 'PAY_NOW' | fallbackTranslate }}</span>
          {{ 'TO_UNLOCK_YOUR_SYSTEM' | fallbackTranslate }}
        </p>
        <button
          type="button"
          class="pay-unlock-btn fw-600"
          (click)="payToUnlock()"
        >
          {{ 'PAY_NOW' | fallbackTranslate }}
        </button>
      </div>
    </div>
  </div>
  <div class="bottom-container flex_sb">
    <!-- Background Color -->
    <div class="qr-img-container">
      <img class="qr-img" [src]="isIndo ? images.QR_CODE_FOR_ID : images.QR_CODE_FOR_AI" alt="qr-code" />
    </div>
    <div class="clr-333 fw-400 lh-140 qr-text">
      {{ 'SCAN_QR_REACH_OUT_TO_CUSTOMER_SUPPORT' | fallbackTranslate }}
    </div>
  </div>
</div>
